import { render, staticRenderFns } from "./OrderSizes.vue?vue&type=template&id=98423210&scoped=true&"
import script from "./OrderSizes.vue?vue&type=script&lang=js&"
export * from "./OrderSizes.vue?vue&type=script&lang=js&"
import style0 from "./OrderSizes.vue?vue&type=style&index=0&id=98423210&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98423210",
  null
  
)

export default component.exports